import { TRADING_COMPANY } from './report-company';
import type { ReportTableDoc, ReportRow } from './report-table-types';

type PurchaseOrderRow = {
  orderNumber: string;
  invoiceNumber: string | null;
  supplierName: string;
  warehouseName: string;
  status: string;
  orderDate: string | Date;
  itemCount: number;
  total: number;
  currency: string;
};

const STATUS_LABELS: Record<string, string> = {
  DRAFT: 'Taslak',
  PENDING_APPROVAL: 'Onay Bekliyor',
  APPROVED: 'Onaylandı',
  PARTIALLY_RECEIVED: 'Kısmi Teslim',
  FULLY_RECEIVED: 'Teslim Alındı',
  CANCELLED: 'İptal',
};

function formatDate(value: string | Date): string {
  const d = value instanceof Date ? value : new Date(value);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}.${month}.${year}`;
}

export function buildPurchaseOrdersDoc(
  rows: PurchaseOrderRow[],
  params: string[] = [],
): ReportTableDoc {
  const dataRows: ReportRow[] = rows.map((o) => ({
    cells: {
      orderNumber: o.orderNumber,
      invoiceNumber: o.invoiceNumber ?? '',
      supplierName: o.supplierName,
      warehouseName: o.warehouseName,
      status: STATUS_LABELS[o.status] ?? o.status,
      orderDate: formatDate(o.orderDate),
      itemCount: o.itemCount,
      total: o.total,
      currency: o.currency,
    },
  }));

  const summaryRow: ReportRow = {
    cells: {
      orderNumber: `${rows.length} sipariş`,
      invoiceNumber: '',
      supplierName: '',
      warehouseName: '',
      status: '',
      orderDate: '',
      itemCount: '',
      total: '',
      currency: '',
    },
    emphasis: 'total',
  };

  return {
    company: TRADING_COMPANY,
    title: 'SATIN ALMA SİPARİŞLERİ',
    generatedLabel: `Oluşturulma: ${new Date().toLocaleString('tr-TR')}`,
    params,
    columns: [
      { key: 'orderNumber',   header: 'Sipariş No',  width: 14 },
      { key: 'invoiceNumber', header: 'Fatura No',   width: 14 },
      { key: 'supplierName',  header: 'Tedarikçi',   width: 22 },
      { key: 'warehouseName', header: 'Depo',        width: 18 },
      { key: 'status',        header: 'Durum',       width: 14, align: 'center' },
      { key: 'orderDate',     header: 'Tarih',       width: 11 },
      { key: 'itemCount',     header: 'Kalem',       width: 8,  num: true },
      { key: 'total',         header: 'Tutar',       width: 13, num: true },
      { key: 'currency',      header: 'Pb',          width: 6,  align: 'center' },
    ],
    rows: [...dataRows, summaryRow],
  };
}
